import React from "react";
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import ToastNotifications from './components/ToastNotifications';
import '@uiw/react-md-editor/markdown-editor.css';
import '@uiw/react-markdown-preview/markdown.css';
import 'react-toastify/dist/ReactToastify.css';
import "./index.css";
import "./App.css";
import './styles/styles.css';
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ToastNotifications />
    <App />
  </BrowserRouter>
);
